import {Row} from "../ui/Box";
import Button from "../ui/Button";
import Icon from "../ui/Icon";

const downStep = (val: number, stepSize: number) => {
  const step = Math.floor((Math.ceil(val) - 1) / stepSize);
  return step * stepSize;
};

const upStep = (val: number, stepSize: number) => {
  const step = Math.ceil((Math.floor(val) + 1) / stepSize);
  return step * stepSize;
};

const stepThreshold = [
  [0, 1],
  [10, 5],
  [25, 25],
  [100, 50],
  [300, 100],
  [1000, 250],
  [2500, 500],
  [5000, 1000],
];

const getDecQuantity = (current: number) => {
  for (let i = 1; i < stepThreshold.length; i++) {
    const [threshold] = stepThreshold[i];
    if (current <= threshold) return downStep(current, stepThreshold[i - 1][1]);
  }
  const last = stepThreshold[stepThreshold.length - 1];
  return downStep(current, last[1]);
};

const getIncQuantity = (current: number) => {
  for (let i = 1; i < stepThreshold.length; i++) {
    const [threshold] = stepThreshold[i];
    if (current < threshold) return upStep(current, stepThreshold[i - 1][1]);
  }
  const last = stepThreshold[stepThreshold.length - 1];
  return upStep(current, last[1]);
};

type PlusMinusButtonsProps = {
  value: number;
  onUpdate: (value: number) => void;
  onDelete: () => void;
  className?: string;
  scale?: "one" | "dynamic";
};
const PlusMinusButtons = (props: PlusMinusButtonsProps) => {
  const {value, onUpdate, onDelete, className, scale} = props;
  const nextDecVal = scale === "one" ? value - 1 : getDecQuantity(value);
  const handleDec = () => {
    if (nextDecVal <= 0) {
      onDelete();
    } else {
      onUpdate(nextDecVal);
    }
  };
  const handleInc = () => {
    onUpdate(scale === "one" ? value + 1 : getIncQuantity(value));
  };
  return (
    <Row className={className}>
      <Button variant="primary" size="md" onClick={handleDec} disabled={value <= 0}>
        {nextDecVal <= 0 ? <Icon name="trash" /> : <Icon name="minus" />}
      </Button>
      <Button variant="primary" size="md" onClick={handleInc}>
        <Icon name="plus" />
      </Button>
    </Row>
  );
};
export default PlusMinusButtons;
